import { render, staticRenderFns } from "./DepartmentsConfigurationGrid.vue?vue&type=template&id=57367ce4&"
import script from "./DepartmentsConfigurationGrid.vue?vue&type=script&lang=js&"
export * from "./DepartmentsConfigurationGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports